
export default {
    inputFieldKeys: {
        USERNAME: 'username',
        PHONE_NUMBER: 'phoneNumber',
        EMAIL: 'email',
        PASSWORD: 'password',
        RE_ENTER_PASSWORD: 'reEnterPassword'
    },
    validationKeys: {
        ALPHA_NUMERIC: 'alpha_numeric',
        ALPHA_SPACE: 'alpha_space',
        EMAIL: 'email',
        ADDRESS: 'address',
        DIGITS: 'digits'
    },
    locale:{
        en:{
            login:{
                header:"Sign In",
                email_label:"Email",
                email_placeholder:"Enter Email",
                password_label:"Password",
                password_placeholder:"Enter Password",
                email_msg:'Please enter valid username',
                password_msg:'Please enter valid username',
                button:"Signin",
                bottomLine:"New member? Signup"
            },
            signup:{
                header:"Sign up",
                email_label:"Email",
                email_placeholder:"Enter Email",
                password_label:"Password",
                password_placeholder:"Enter Password",
                username_label:"Username",
                username_placeholder:"Enter Username",
                mobile_label:"Mobile Number",
                mobile_placeholder:"Enter Mobile Number",
                repassword_label:"Confirm Password",
                repassword_placeholder:"Re-enter Password",
                username_msg:'Please enter valid username',
                mobile_msg:'Please enter valid mobile number',
                email_msg:'Please enter valid email',
                password_msg:'Please enter valid password',
                repassword_msg:'Please confirm password',
                button:"Signup",
                bottomLine:"Already a member? Signin"
            },
            organization:{
                header:"Organization",
                name_label:"Organization Name",
                name_placeholder:"Enter Organization Name",
                address_label:"Registered Address",
                address_placeholder:"Enter Registered Address",
                type_label:"Organization Type",
                type_placeholder:"Enter Organization Type",
                gst_label:"GST Number",
                gst_placeholder:"Enter GST Number",
                gst_date_label:"GST Registration Date",
                gst_date_placeholder:"Select GST Registration Date",
                pan_label:"PAN Card",
                pan_placeholder:"Enter PAN Card",
                about_label:"About Organization",
                about_placeholder:"",
                name_msg:'Please enter valid Organization Name',
                address_msg:'Please enter valid Registered Address',
                type_msg:'Please enter Organization Type',
                gst_msg:'Please enter GST Number',
                gst_date_msg:'Please enter GST Registration Date',
                pan_msg:'Please enter PAN Card',
                button:"Let's Get Started!"
            },
            editProfile:{
                header:"Update Profile",
                email_label:"Email",
                email_placeholder:"Enter Email",
                password_label:"Password",
                password_placeholder:"Enter Password",
                username_label:"Username",
                username_placeholder:"Enter Username",
                mobile_label:"Mobile Number",
                mobile_placeholder:"Enter Mobile Number",
                repassword_label:"Confirm Password",
                repassword_placeholder:"Re-enter Password",
                username_msg:'Please enter valid username',
                mobile_msg:'Please enter valid mobile number',
                email_msg:'Please enter valid email',
                password_msg:'Please enter valid password',
                repassword_msg:'Please confirm password',
                button:"Update",
            },
            home:{
                header:"Feeds"
            },
            uploadDoc:{
                header:'Upload Documents',
                cameraTitle:"Capture Bill",
                docTitle:"Upload Bill",
                amountTitle:"Enter Amount",
                description:"Enter Description",
                billTypes:{
                    type1:'Sell-Kachu',
                    type2:'Sell-Paku',
                    type3:'Buy-Paku',
                    type4:'Buy-Kachu',
                },
                uploadDocLabel:"Browse",
                amountInputs:{
                    company:'Enter Company Name',
                    gst:'Enter GST No.',
                    amount:'Enter Amount',
                },
                typeSelect:'Select Type',
                button:'Upload'
            },
            notification:{
                header:"Notifications"
            },
            profile:{
                header:"Profile",
                userDetails:{
                    username:"Username",
                    email:"E-Mail"
                },
                actions:{
                    updateProfile:"Update Profile",
                    aboutUs:'About Us',
                    tnc:'Terms and Conditions',
                    lang:'Change Language',
                    logout:'Logout'
                }
            },
            lang:{
                header:'Select Language'
            },
            transDetails:{
                name:'Name',
                email:'E-Mail',
                mobile:'Mobile',
                description:'Description'
            }
        },
        gu:{
            login:{
                header:"સાઇન ઇન",
                email_label:"ઇમેઇલ",
                email_placeholder:"ઇમેઇલ દાખલ કરો",
                password_label:"પાસવર્ડ",
                password_placeholder:"પાસવર્ડ દાખલ કરો",
                button:"સાઇન-ઇન",
                bottomLine:"નવા સભ્ય? સાઇનઅપ"
            },
            signup:{
                header:"સાઇન અપ",
                email_label:"ઇમેઇલ",
                email_placeholder:"ઇમેઇલ દાખલ કરો",
                password_label:"પાસવર્ડ",
                password_placeholder:"પાસવર્ડ દાખલ કરો",
                username_label:"વપરાશકર્તા નામ",
                username_placeholder:"વપરાશકર્તા નામ દાખલ કરો",
                mobile_label:"મોબાઇલ નંબર",
                mobile_placeholder:"મોબાઇલ નંબર દાખલ કરો",
                repassword_label:"પાસવર્ડની પુષ્ટિ કરો",
                repassword_placeholder:"પાસવર્ડ ફરીથી નાખો",
                username_msg:'કૃપા કરી માન્ય વપરાશકર્તાનામ દાખલ કરો',
                mobile_msg:'કૃપા કરી માન્ય મોબાઇલ નંબર દાખલ કરો',
                email_msg:'કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો',
                password_msg:'કૃપા કરી માન્ય પાસવર્ડ દાખલ કરો',
                repassword_msg:'કૃપા કરીને પાસવર્ડની પુષ્ટિ કરો',
                button:"સાઇન અપ કરો",
                bottomLine:"પહેલેથી જ એક સભ્ય? સાઇન ઇન"
            },
            organization:{
                header:"સંસ્થા",
                name_label:"સંસ્થા નામ",
                name_placeholder:"સંસ્થા નામ દાખલ કરો",
                address_label:"રજિસ્ટર્ડ સરનામું",
                address_placeholder:"રજિસ્ટર્ડ સરનામું દાખલ કરો",
                type_label:"સંસ્થા પ્રકાર",
                type_placeholder:" સંસ્થા પ્રકાર દાખલ કરો",
                gst_label:"જીએસટી નંબર",
                gst_placeholder:" જીએસટી નંબર દાખલ કરો",
                gst_date_label:"જીએસટી નોંધણી તારીખ",
                gst_date_placeholder:"જીએસટી નોંધણી તારીખ દાખલ કરો",
                pan_label:"પાનકાર્ડ",
                pan_placeholder:" પાનકાર્ડ દાખલ કરો",
                about_label:"સંસ્થા વિશે",
                about_placeholder:"",
                name_msg:'કૃપા કરી માન્ય સંસ્થા નામ દાખલ કરો',
                address_msg:'કૃપા કરી માન્ય રજિસ્ટર્ડ સરનામું દાખલ કરો',
                type_msg:'કૃપા કરી માન્ય સંસ્થા પ્રકાર દાખલ કરો',
                gst_msg:'કૃપા કરી માન્ય જીએસટી નંબર દાખલ કરો',
                gst_date_msg:'કૃપા કરી માન્ય જીએસટી નોંધણી તારીખ દાખલ કરો',
                pan_msg:'કૃપા કરી માન્ય પાનકાર્ડ દાખલ કરો',
                button:"ચાલો, શરુ કરીએ!"
            },
            editProfile:{
                header:"પ્રોફાઇલ અપડેટ કરો",
                email_label:"ઇમેઇલ",
                email_placeholder:"ઇમેઇલ દાખલ કરો",
                password_label:"પાસવર્ડ",
                password_placeholder:"પાસવર્ડ દાખલ કરો",
                username_label:"વપરાશકર્તા નામ",
                username_placeholder:"વપરાશકર્તા નામ દાખલ કરો",
                mobile_label:"મોબાઇલ નંબર",
                mobile_placeholder:"મોબાઇલ નંબર દાખલ કરો",
                repassword_label:"પાસવર્ડની પુષ્ટિ કરો",
                repassword_placeholder:"પાસવર્ડ ફરીથી નાખો",
                username_msg:'કૃપા કરી માન્ય વપરાશકર્તાનામ દાખલ કરો',
                mobile_msg:'કૃપા કરી માન્ય મોબાઇલ નંબર દાખલ કરો',
                email_msg:'કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો',
                password_msg:'કૃપા કરી માન્ય પાસવર્ડ દાખલ કરો',
                repassword_msg:'કૃપા કરીને પાસવર્ડની પુષ્ટિ કરો',
                button:"અપડેટ",
            },
            home:{
                header:"ફીડ્સ"
            },
            uploadDoc:{
                header:'દસ્તાવેજો અપલોડ કરો',
                cameraTitle:"કેપ્ચર બિલ",
                docTitle:"બિલ અપલોડ કરો",
                amountTitle:"રકમ દાખલ કરો",
                description:"વર્ણન લખો",
                billTypes:{
                    type1:'કચુ-વેચો',
                    type2:'પાકુ-વેચો',
                    type3:'ખરીદો-પાકુ',
                    type4:'ખરીદો-કચુ',
                },
                uploadDocLabel:"બ્રાઉઝ કરો",
                amountInputs:{
                    company:'કંપનીનું નામ દાખલ કરો',
                    gst:'જીએસટી નંબર દાખલ કરો',
                    amount:'રકમ દાખલ કરો',
                },
                typeSelect:'પ્રકાર પસંદ કરો',
                button:'અપલોડ કરો'
            },
            notification:{
                header:"સૂચનાઓ"
            },
            profile:{
                header:"પ્રોફાઇલ",
                userDetails:{
                    username:"વપરાશકર્તા નામ",
                    email:"ઇ-મેઇલ"
                },
                actions:{
                    updateProfile:"પ્રોફાઇલ અપડેટ કરો",
                    aboutUs:'અમારા વિશે',
                    tnc:'નિયમો અને શરત',
                    lang:'ભાષા બદલો',
                    logout:'લૉગ આઉટ'
                }
            },
            lang:{
                header:'ભાષા પસંદ કરો'
            },
            transDetails:{
                name:'નામ',
                email:'ઇમેઇલ',
                mobile:'મોબાઇલ નંબર',
                description:'વર્ણન'
            }
        },
        hi:{
            login:{
                header:"साइन इन करें",
                email_label:"ईमेल",
                email_placeholder:"ईमेल दर्ज करें",
                password_label:"पास वर्ड",
                password_placeholder:"पास वर्ड दर्ज करें",
                button:"साइन-इन करें",
                bottomLine:"नया सदस्य? साइन अप करें"
            },
            signup:{
                header:"साइन अप",
                email_label:"ईमेल",
                email_placeholder:"ईमेल दर्ज करें",
                password_label:"पास वर्ड",
                password_placeholder:"पास वर्ड दर्ज करें",
                username_label:"उपयोगकर्ता नाम",
                username_placeholder:"उपयोगकर्ता नाम दर्ज करें",
                mobile_label:"फोन नंबर",
                mobile_placeholder:"फोन नंबर दर्ज करें",
                repassword_label:"पासवर्ड की पुष्टि कीजिये",
                repassword_placeholder:"पासवर्ड फिर से दर्ज करें",
                username_msg:'कृपया मान्य उपयोगकर्ता नाम दर्ज करें',
                mobile_msg:'कृपया मान्य मोबाइल नंबर दर्ज करें',
                email_msg:'कृपया मान्य मोबाइल नंबर दर्ज करें',
                password_msg:'कृपया मान्य पासवर्ड दर्ज करें',
                repassword_msg:'कृपया पासवर्ड की पुष्टि करें',
                button:"साइन अप करें",
                bottomLine:"पहले से सदस्य हैं? साइन इन करें"
            },
            organization:{
                header:"संगठन का नाम",
                name_label:"संगठन का नाम",
                name_placeholder:"संगठन का नाम दर्ज करें",
                address_label:"पंजीकृत पता",
                address_placeholder:"पंजीकृत पता दर्ज करें",
                type_label:"संगठन का प्रकार",
                type_placeholder:"संगठन का प्रकार दर्ज करें",
                gst_label:"जीएसटी नंबर",
                gst_placeholder:"जीएसटी नंबर दर्ज करें",
                gst_date_label:"जीएसटी पंजीकरण की तारीख",
                gst_date_placeholder:"जीएसटी पंजीकरण की तारीख दर्ज करें",
                pan_label:"पैन कार्ड",
                pan_placeholder:"पैन कार्ड दर्ज करें",
                about_label:"संगठन के बारे में",
                about_placeholder:"",
                name_msg:'कृपया मान्य संगठन का नाम दर्ज करें',
                address_msg:'कृपया मान्य पंजीकृत पता दर्ज करें',
                type_msg:'कृपया मान्य संगठन का प्रकार दर्ज करें',
                gst_msg:'कृपया मान्य जीएसटी नंबर दर्ज करें',
                gst_date_msg:'कृपया मान्य जीएसटी पंजीकरण की तारीख दर्ज करें',
                pan_msg:'कृपया मान्य पैन कार्ड दर्ज करें',
                button:"आएँ शुरू करें!"
            },
            editProfile:{
                header:"प्रोफ़ाइल अपडेट करें",
                email_label:"ईमेल",
                email_placeholder:"ईमेल दर्ज करें",
                password_label:"पास वर्ड",
                password_placeholder:"पास वर्ड दर्ज करें",
                username_label:"उपयोगकर्ता नाम",
                username_placeholder:"उपयोगकर्ता नाम दर्ज करें",
                mobile_label:"फोन नंबर",
                mobile_placeholder:"फोन नंबर दर्ज करें",
                repassword_label:"पासवर्ड की पुष्टि कीजिये",
                repassword_placeholder:"पासवर्ड फिर से दर्ज करें",
                username_msg:'कृपया मान्य उपयोगकर्ता नाम दर्ज करें',
                mobile_msg:'कृपया मान्य मोबाइल नंबर दर्ज करें',
                email_msg:'कृपया मान्य मोबाइल नंबर दर्ज करें',
                password_msg:'कृपया मान्य पासवर्ड दर्ज करें',
                repassword_msg:'कृपया पासवर्ड की पुष्टि करें',
                button:"अपडेट"
            },
            home:{
                header:"फ़ीड"
            },
            uploadDoc:{
                header:'दस्तावेज़ अपलोड करें',
                cameraTitle:"फोटो बिल अपलोड करें",
                docTitle:"बिल अपलोड करें",
                amountTitle:"राशी डालें",
                description:"विवरण लिखें",
                billTypes:{
                    type1:'बेचना-कच्चा',
                    type2:'बेचना-पक्के',
                    type3:'खरीदें-पक्के',
                    type4:'खरीदें-कच्चा',
                },
                uploadDocLabel:"ब्राउज़",
                amountInputs:{
                    company:'कंपनी का नाम दर्ज करें',
                    gst:'जीएसटी संख्या दर्ज करें',
                    amount:'राशी डालें',
                },
                typeSelect:'प्रकार चुनें',
                button:'अपलोड करें'
            },
            notification:{
                header:"सूचनाएं"
            },
            profile:{
                header:"प्रोफ़ाइल",
                userDetails:{
                    username:"उपयोगकर्ता नाम",
                    email:"ईमेल"
                },
                actions:{
                    updateProfile:"प्रोफ़ाइल अपडेट करें",
                    aboutUs:'हमारे बारे में',
                    tnc:'नियम और शर्तें',
                    lang:'भाषा बदलो',
                    logout:'लॉग आउट करें'
                }
            },
            lang:{
                header:'भाषा का चयन करें'
            },
            transDetails:{
                name:'नाम',
                email:'ईमेल',
                mobile:'फोन नंबर',
                description:'विवरण'
            }
        }
    }
}